"use strict";

//Quick View
document.addEventListener("DOMContentLoaded", function () {
  var quickViewButton = $('a.quick-view-btn');
  //console.log('quickViewButton: ', quickViewButton);

  if ($(window).width() > 767) {
    quickViewButton.click(function (e) {
      e.preventDefault();
      var productHandle = $(this).attr('data-handle');
      getQuickViewProd(productHandle);
    });
  }
});
function getQuickViewProd(productHandle) {
  var popupWrapper = $('.popup_full');
  $.ajax({
    url: '/products/' + productHandle + '?view=quick-view',
    method: 'GET',
    //dataType: 'jsonp',
    success: function success(data) {
      popupWrapper.html(data);
      popupWrapper.find('.quick-view-popup').addClass('opened');
      popupWrapper.fadeIn('fast');
      popupWrapper.addClass('active-quick-view');
      $('body').addClass('fxd-active');
      popupSlickGallery();
      prodDDFunctions($(".popup_full .quick-view-popup .product-form"));
      addToCartButton($(".popup_full .quick-view-popup .product-form"));
      $('.popup_full .quick-view-popup .okeReviews-reviewsSummary').click(function () {
        location.href = $(this).parents(".quick-view-popup").attr("data-pdp-link");
      });
    },
    error: function error(_error) {
      //console.log(error); // log any errors to the console
    }
  });
}
function popupSlickGallery() {
  var popupWrapper = $('.popup_full');
  popupWrapper.find('.quick-view-popup .quick-view-image-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: popupWrapper.find('.quick-view-popup .quick-view-image-thumbs'),
    focusOnSelect: true
  });
  popupWrapper.find('.quick-view-popup .quick-view-image-thumbs').slick({
    //slidesToShow: ((popupWrapper.find('.quick-view-popup .quick-view-image-thumbs img').length > 6) ? 6 : popupWrapper.find('.quick-view-popup .quick-view-image-thumbs img').length),
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: popupWrapper.find('.quick-view-popup .quick-view-image-main'),
    //arrows: ((popupWrapper.find('.quick-view-popup .quick-view-image-thumbs img').length > 6) ? true : false),
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
}